import React from "react";
import { Upload, Modal } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import "./index.css";
import { apiURL } from "../../../../utlis/config";
import store from "store";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class MultipalImage extends React.Component {
  state = {
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    // file:
    fileList: this.props.pictursList || [],
    // fileList: [
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url:
    //     "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    // },
    //   {
    //     uid: "-2",
    //     name: "image.png",
    //     status: "done",
    //     url:
    //       "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    //   },
    //   {
    //     uid: "-3",
    //     name: "image.png",
    //     status: "done",
    //     url:
    //       "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    //   },
    //   {
    //     uid: "-4",
    //     name: "image.png",
    //     status: "done",
    //     url:
    //       "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    //   },
    //   {
    //     uid: "-5",
    //     name: "image.png",
    //     status: "error",
    //   },
    // ],
  };
  componentDidUpdate() {
    const { file, fileList } = this.state;
    const { onProductImageChange } = this.props;
    if (file) {
      const { status, response } = file;
      if (status !== "uploading") {
        if (status === "done") {
          // const { response } = file;
          var listObject = {};
          listObject["uid"] = file.uid;
          listObject["name"] = file.name;
          listObject["status"] = status;
          if (!response.error && response.status === 200) {
            listObject["status"] = status;
            listObject["url"] = apiURL + response.data;
            if (fileList.length) {
              fileList[fileList.length - 1] = listObject;
            } else {
              fileList.push(listObject);
            }
            this.setState({ fileList, file: undefined });
            onProductImageChange(fileList);
            // examImageUrl = response.data;
            //  onChangeImage(response.data);
          } else {
            var listObject = {};
            listObject["uid"] = file.uid;
            listObject["name"] = file.name;
            listObject["status"] = status;
            listObject["status"] = "error";
            if (fileList.length) {
              fileList[fileList.length - 1] = listObject;
            } else {
              fileList.push(listObject);
            }
            this.setState({ fileList, file: undefined });
            onProductImageChange(fileList);
          }
        } else if (status === "error") {
          var listObject = {};
          listObject["uid"] = file.uid;
          listObject["name"] = file.name;
          listObject["status"] = status;
          listObject["status"] = status;
          if (fileList.length) {
            fileList[fileList.length - 1] = listObject;
          } else {
            fileList.push(listObject);
          }
          this.setState({ fileList, file: undefined });
          onProductImageChange(fileList);
          // that.showErrorMessage("Uploading failed. Please try again");
        }
      } else if (status === "removed") {
        onProductImageChange(fileList);
      }
    }
  }
  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };

  handleChange = ({ file, fileList }) => {
    // var fileList = [{ status: "done" }];
    const { onProductImageChange } = this.props;
    console.log({ file, fileList });
    this.setState({ file, fileList });
    if (file.status === "removed") {
      onProductImageChange(fileList);
    }
    // const { status } = file;

    // console.log({ status });
  };
  render() {
    const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    // console.log({ fileList });
    const uploadButton = (
      <div>
        {/* <PlusOutlined /> */}
        <i className="fa fa-plus"></i>
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    const uploadProps = {
      name: "image",
      //   multiple: true,
      crossDomain: true,
      action: `${apiURL}/media`,
      headers: {
        Authorization: `Bearer ${store.get("authToken")}`,
      },
      onChange(info) {
        const { status, response } = info.file;
        if (status !== "uploading") {
        }
        if (status === "done") {
          if (!response.error && response.status === 200) {
            console.log({
              response: apiURL + response.data,
            });
            this.setState({ fileList: response.data });
            // examImageUrl = response.data;
            //  onChangeImage(response.data);
          }
        } else if (status === "error") {
          // that.showErrorMessage("Uploading failed. Please try again");
        }
      },
    };
    return (
      <div className="clearfix" id="hide-icon-preview">
        <Upload
          action={`${apiURL}/media`}
          headers={{
            Authorization: `Bearer ${store.get("authToken")}`,
          }}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          // onChange={this.handleChange}
          //   {...uploadProps}
        >
          {/* {fileList.length >= 4 ? null : uploadButton} */}
        </Upload>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}

export default MultipalImage;
